import {noop} from 'lodash';
import {FC, Fragment, ReactNode, RefObject} from 'react';
import {PopupProps} from 'semantic-ui-react';

import HoverableButton from '../HoverableButton';
import ButtonAlert from '../ButtonAlert';
import {SharedTooltip} from '../../../components/graphs/GraphTooltips';
import RackEditorStore from '../../store/RackEditorStore';

class BaseActionButton {
  icon: string = '';
  tooltip: string = '';
  containerRef: RefObject<HTMLDivElement>;

  rackEditorStore: RackEditorStore;
  sharedTooltip: SharedTooltip;

  constructor(rackEditorStore: RackEditorStore, sharedTooltip: SharedTooltip, containerRef: RefObject<HTMLDivElement>) {
    this.rackEditorStore = rackEditorStore;
    this.sharedTooltip = sharedTooltip;
    this.containerRef = containerRef;
  }

  popupCommonProps = (): PopupProps => {
    return {
      ...(this.containerRef?.current ? {mountNode: this.containerRef.current} : {}),
      inverted: false,
      basic: true,
      position: 'top center',
      size: 'tiny',
      trigger: this.renderButton(),
      flowing: true,
      hoverable: true,
      pinned: true,
      on: []
    };
  };

  showActionTooltip = (title?: string) => (e: MouseEvent) => {
    if (title) {
      this.sharedTooltip?.show(title);
    } else {
      this.sharedTooltip?.hide();
    }
    e.stopPropagation();
  };

  hidePopups = (hideLinker?: boolean, hideNodeProperties?: boolean) => {
    const {rackStore} = this.rackEditorStore;

    this.showActionTooltip();
    rackStore.editNode();
    if (hideLinker) rackStore.toggleLinker();
    if (hideNodeProperties) rackStore.toggleOptions(true);
  };

  error = (): ReactNode => '';

  disabled = () => false;

  visible = () => true;

  onClick = noop;

  renderButton = () => {
    return (
      <HoverableButton
        size='large'
        primary
        icon={this.icon}
        aria-label={this.tooltip}
        disabled={this.disabled()}
        onClick={this.onClick}
        onMouseOver={this.showActionTooltip(this.tooltip)}
        onMouseOut={this.showActionTooltip()}
      />
    );
  };

  renderWithAlerts = (index: number) => {
    return (
      <Fragment key={index}>
        {
          !!index && <ButtonAlert message={this.error()} />
        }
        {
          this.render({})
        }
        {
          !index && <ButtonAlert message={this.error()} shiftLeft />
        }
      </Fragment>
    );
  };

  render: FC = () => {
    return this.renderButton();
  };
}

export {BaseActionButton};
